import React from "react";
import Jumbotron from "../components/JumbotronComponent";
import { motion } from "framer-motion";

const Home = () => {
  return (
    <motion.div
      id="homeheader"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Jumbotron
        heading="Joe's Pressure Washing"
        subheading="Washing Done right!"
        calltoaction="Contact Me"
        paragraph=""
        link="/contact"
      />
    </motion.div>
  );
};

export default Home;
